import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { CanLoad, CanLoadCtor, mixinLoading } from '../core/common-behaviors';

/* eslint-disable @angular-eslint/no-inputs-metadata-property */

// Boilerplate for applying mixins to RdsVersionedCodeSnippetsComponent.
class RdsVersionedCodeSnippetsBase {}
const _RdsVersionedCodeSnippetsMixinBase: CanLoadCtor = mixinLoading(RdsVersionedCodeSnippetsBase);

/**
 * Layout component that displays the different supported version of a generator
 * and the code snippet for each version.
 *
 * @author Will Davis <will.davis@mtna.us>
 */
@Component({
  selector: 'rds-c-versioned-code-snippets',
  template: `
    <mat-drawer-container autosize>
      <mat-drawer mode="side" opened>
        <mat-action-list>
          <h3 matSubheader>VERSIONS</h3>
          <ng-container *ngFor="let version of versions">
            <button mat-list-item [class.active]="selected === version" (click)="selectionChange.emit(version)">
              {{ version }}
            </button>
            <mat-divider></mat-divider>
          </ng-container>
        </mat-action-list>
      </mat-drawer>
      <mat-drawer-content>
        <mat-spinner *ngIf="loading; else linesOfCode" class="rds-c-snippets-dialog-generators-loader"></mat-spinner>
        <ng-template #linesOfCode>
          <rds-c-code-snippet [clipboardCode]="loc | rdsLocClipboard" [html]="loc | rdsLocHtml"></rds-c-code-snippet>
        </ng-template>
      </mat-drawer-content>
    </mat-drawer-container>
  `,
  styleUrls: ['./versioned-code-snippets.component.scss'],
  inputs: ['loading'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class RdsVersionedCodeSnippetsComponent extends _RdsVersionedCodeSnippetsMixinBase implements CanLoad {
  /** The lines of code that make up the code snippet */
  @Input() loc: string[] | undefined;
  /** The selected version */
  @Input() selected: string | undefined;
  /** All the versions for the given library */
  @Input() versions: string[] | undefined;

  /** Emitted when a version is selected */
  @Output() selectionChange = new EventEmitter<string>();
}
